import SwiperSlider from "./abstract/SwiperSlider";
import $ from "jquery";

export default class CenteredSlider extends SwiperSlider {
  constructor(element, context) {
    super(element, context);

    this.options = {
      slidesPerView: 1.3,
      autoHeight: false,
      watchOverflow: true,
      spaceBetween: 20,
      loop: false,
      centeredSlides: true,
      centeredSlidesBounds: true,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        576: {
          slidesPerView: 2.3,
          centeredSlides: true,
          centeredSlidesBounds: true,
        },
        768: {
          slidesPerView: 3.4,
          centeredSlides: true,
          centeredSlidesBounds: true,
        },
        992: {
          slidesPerView: 4,
          centeredSlides: false,
          centeredSlidesBounds: false,
        }
      }
    };

    if (!!this.getData('small')) {
      this.options.centeredSlides = false;
      this.options.centeredSlidesBounds = false;
      this.options.centerInsufficientSlides = false;
      this.options.breakpoints = {
        576: {
          slidesPerView: 2.3,
        },
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        }
      };
    }

    $(() => {
      this.init();
    });
  }
}
